"use client"

import { AppLogo } from "@/components/app-logo"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Footer } from "@/components/ui/footer"
import { useLanguage } from "@/lib/i18n/language-provider"
import { ArrowLeft, Download, Monitor, Apple } from "lucide-react"
import SmartLink from "@/components/smart-link"
import InteractiveButton from "@/components/downloads/interactive-button"

export default function DownloadsPage() {
  const { t } = useLanguage()
  const windowsRequirements = [
    t("downloads.windows.req.os"),
    t("downloads.windows.req.cpu"),
    t("downloads.windows.req.ram"),
    t("downloads.windows.req.gpu"),
  ]
  const macRequirements = [
    t("downloads.macos.req.os"),
    t("downloads.macos.req.cpu"),
    t("downloads.macos.req.ram"),
    t("downloads.macos.req.gpu"),
  ]
  return (
    <div className="min-h-screen bg-background text-foreground p-3 md:p-4 flex flex-col">
      <div className="max-w-5xl mx-auto w-full">
        <div className="border-b mb-4 md:mb-6">
          <div className="flex h-14 md:h-16 items-center px-2 md:px-4">
            <Button variant="ghost" size="icon" onClick={() => {
              if (typeof window !== 'undefined' && window.location?.protocol === 'file:') {
                const pathname = window.location.pathname || '';
                const outIdx = pathname.lastIndexOf('/out/');
                const base = outIdx >= 0 ? pathname.substring(0, outIdx + '/out/'.length) : pathname;
                window.location.href = base + 'index.html';
              } else {
                if (window.history.length > 1) window.history.back();
                else window.location.href = '/';
              }
            }} className="h-9 w-9 md:h-10 md:w-10">
              <ArrowLeft className="h-5 w-5 md:h-6 md:w-6" />
            </Button>
            <div className="ml-2 md:ml-4 flex items-center gap-2">
              <AppLogo />
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold tracking-tight">{t("downloads.title")}</h1>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
          <InteractiveButton
            title={t("downloads.windows.title")}
            subtitle={t("downloads.windows.subtitle")}
            icon={<Monitor />}
            requirements={windowsRequirements}
            onDownload={() => {
              window.open("https://mega.nz/folder/3HY10TKI#CDmOmNzgLmJItcA5wDFjBg", "_blank");
            }}
          />
          <InteractiveButton
            title={t("downloads.macos.title")}
            subtitle={t("downloads.macos.subtitle")}
            icon={<Apple />}
            requirements={macRequirements}
            onDownload={() => {
              window.open("https://mega.nz/folder/2OY1kTSJ#8YHUbyhqV_QQjavgEW3iww", "_blank");
            }}
          />
        </div>
        <style jsx>{`
          @keyframes float { 0%, 100% { transform: translateY(0px) rotate(0deg); } 50% { transform: translateY(-10px) rotate(180deg); } }
          .shadow-3xl { box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.8); }
        `}</style>
      </div>
      <Footer />
    </div>
  )
} 